/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.articleCards", {
       
        _create: function () {
            this.wrap = this.element;
           
            $('.s-carousel-article__wrp').addClass('opacityLeft').addClass('opacityRight')

            
            this._createDotContainer();
            this._createArrowContainer()
         
            this._initSlick();
            //this._setOpacity();
        },

        _initSlick(){     

            this.wrap.slick({
                lazyLoad: 'progressive',
                edgeFriction: api.vars.slick.edgeFriction,
                infinite: false,
                arrows: api.fn.getData(this.wrap, 'arrows', true),
                appendArrows: this.wrap.parents('.s-carousel-article__row').find('.carousel_arrows'),
                prevArrow: api.vars.slick.prevArrow,
                nextArrow: api.vars.slick.nextArrow,
                dots: api.fn.getData(this.wrap, 'dots', false),
                appendDots: this.wrap.parent().find('.carousel_dots'),
                rows: 0,
                slidesToShow:1,
                slidesToScroll: parseInt(this.wrap.attr('data-scrollItems')),
                appendArrows: this.wrap
                .parents(".s-carousel-article__body")
                .find(".carousel_arrows"),
                variableWidth:false,
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet ,
                        settings: {
                            variableWidth: true,                           
                        },
                    }
                ],
            });        
           
            this.wrap.on('beforeChange', (slick, currentSlide, nextSlide) => {
                this.wrap.find('[data-src]').lazy();
            });

        },        

        _createDotContainer() {
            $('<div class="carousel_dots"></div>').insertBefore(this.wrap);
        },
        _createArrowContainer() {
            $('<div class="carousel_arrows"></div>').appendTo(this.wrap.parents('.s-carousel-article__row'));
        },
       
    });
})(jQuery);
